import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { noop } from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Input } from '~/elements/Input';
import { TermsAndConditions } from '.';
import styles from './registerForm.module.css';
import Api from '~/api';
import { registerViewerName } from '~/api/NewViewer';
import Loader from '~/elements/Loader';
import { fullNameSchema } from '~/utils/validation';
import { useFingerPrint } from '~/components/FingerPrintProvider';
const schema = yup.object({
    fullName: fullNameSchema.required('Name is required'),
    tandc: yup
        .bool()
        .oneOf([true], 'Please agree to the T&C and Privacy Policy')
        .required('Please agree to the T&C and Privacy Policy'),
});
const NameOnly = (props) => {
    const [loading, setLoading] = React.useState(false);
    const { fingerprint, verifyUser } = process.env.NODE_ENV === 'test'
        ? {
            fingerprint: 'mockFingerPrint',
            verifyUser: noop(),
        }
        : useFingerPrint();
    const { control, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        Api.Analytics.submitOgrForm();
        try {
            await registerViewerName(Number(props.event.id), data.fullName, fingerprint);
            verifyUser();
            setLoading(false);
            props.onRegister();
        }
        catch (error) {
            setLoading(false);
        }
    });
    return (_jsxs("form", { className: styles.form, onSubmit: onSubmit, children: [_jsx(Input, { label: "Your Name", name: "fullName", control: control, isRequired: true }), _jsx(Input, { label: "Terms and Conditions", name: "tandc", control: control, type: "checkbox", children: _jsx(TermsAndConditions, {}) }), _jsx("button", { className: styles.registerButton, disabled: loading, children: loading ? _jsx(Loader, { size: 24, color: "white" }) : 'Register to Watch' })] }));
};
export default NameOnly;
